// Import Dependencies
// Import Components
import Grid from "@material-ui/core/Grid";
import { TimelineLite } from "gsap/all";
import React, { Component } from "react";
import { Redirect } from "react-router-dom";
//import Transition from "react-transition-group/Transition";
import { di } from "../../bottle";
import { Container, Header } from "../../components";
import { customTheme } from "../../themeProvider";
import { BikeCard } from "./components/BikeCard";
import { bikeImages } from "./BikeImages";

// Component
class Selection extends Component {
  constructor(props) {
    // call base constructor
    super(props);

    // initialize instance variables
    this.animator = new TimelineLite({ paused: true });
    this.ryker900 = null;
    this.bikeImages = bikeImages

    // initialize state
    this.state = {
      show: false,
      showInfo600: false,
      showInfo900: false,
      showInfoAR: false,
      redirect: false,
    };
  }

  componentDidMount() {
    if (this.ryker900) {
      // this.animator
      //   .from(this.ryker900.container.div, 1, { autoAlpha: 0 })
      //   .play();
      this.setState({ show: true });
    }
  }

  onSelectModel = async (model, engine) => {
    await di.modelManager.resetCamera();
    await di.garage.resetBike(model, engine);
    di.modelManager.hideAllParts();
    di.modelManager.showBike(di.garage.bike);
    setTimeout(
      () =>
        this.setState({
          redirect: true,
        }),
      500
    );
  };

  render() {
    const { classes } = this.props;
    const region = di.profileManager.region
    

    if (this.state.redirect) {
      return (
        <Redirect
          to={{
            pathname: "/customization",
            search: this.props.location.search,
          }}
        />
      );
    }

    const hidePrice = di.profileManager.hidePrice()

    const STD600price = !hidePrice && di.catalogManager.priceForPart("STD", "602").toString();
    const STD900price = !hidePrice && di.catalogManager.priceForPart("STD", "903").toString();
    const ARprice = !hidePrice && di.catalogManager.priceForPart("AR").toString();
    const SPORTprice = !hidePrice && di.catalogManager.priceForPart("SPORT").toString();
    const dataLayer = window.dataLayer || [];

    return (
      <Grid container className={classes.container}>
        <Container flex>
          <Header />
          <div style={styles.cardContainer}>
            <BikeCard
              style={{ transform: "translateX(100px)" }}
              title={di.localization.get("selection.ryker600.title")}
              price={STD600price}
              startingAt={di.localization.get("selection.ryker600.startingAt")}
              subtitle={di.localization.get("selection.ryker600.subtitle")}
              description={di.localization.get(
                "selection.ryker600.description"
              )}
              background={require("./assets/bg-r-600.png")}
              asset={require(`./assets/${this.bikeImages["STD"][602][region]}`)}
              onPressButton={() => {
                dataLayer.push({
                  event: "e_selectionCta",
                  model: "can-am ryker rotax 600 ace",
                  country: di.profileManager.region,
                  language: di.localization.locale,
                });
                this.onSelectModel("STD", "602");
              }}
              isExcluded={di.catalogManager.isExcluded("STD.602", region)}
            />

            <BikeCard
              ref={(ref) => (this.ryker900 = ref)}
              title={di.localization.get("selection.ryker900.title")}
              price={STD900price}
              startingAt={di.localization.get("selection.ryker900.startingAt")}
              subtitle={di.localization.get("selection.ryker900.subtitle")}
              description={di.localization.get(
                "selection.ryker900.description"
              )}
              asset={require(`./assets/${this.bikeImages["STD"][903][region]}`)}
              background={require("./assets/bg-r-900.png")}
              onPressButton={() => {
                dataLayer.push({
                  event: "e_selectionCta",
                  model: "can-am ryker rotax 900 ace",
                  country: di.profileManager.region,
                  language: di.localization.locale,
                });
                this.onSelectModel("STD", "903");
              }}
              isExcluded={di.catalogManager.isExcluded("STD.903", region)}
            />

            <BikeCard
              style={{ transform: "translateX(100px)" }}
              title={di.localization.get("selection.rykerSport.title")}
              price={SPORTprice}
              startingAt={di.localization.get(
                "selection.rykerSport.startingAt"
              )}
              subtitle={di.localization.get("selection.rykerSport.subtitle")}
              description={di.localization.get(
                "selection.rykerSport.description"
              )}
              background={require("./assets/bg-sport.png")}
              asset={require(`./assets/${this.bikeImages["SPORT"][903][region]}`)}
              onPressButton={() => {
                dataLayer.push({
                  event: "e_selectionCta",
                  model: "can-am ryker rotax Sport Edition",
                  country: di.profileManager.region,
                  language: di.localization.locale,
                });
                this.onSelectModel("SPORT", "903");
              }}
              isExcluded={di.catalogManager.isExcluded("SPORT.903", region)}
            />

            <BikeCard
              style={{ transform: "translateX(-100px)" }}
              title={di.localization.get("selection.rykerRally.title")}
              price={ARprice}
              startingAt={di.localization.get(
                "selection.rykerRally.startingAt"
              )}
              subtitle={di.localization.get("selection.rykerRally.subtitle")}
              description={di.localization.get(
                "selection.rykerRally.description"
              )}
              asset={require(`./assets/${this.bikeImages["AR"][903][region]}`)}
              background={require("./assets/bg-rally.png")}
              onPressButton={() => {
                dataLayer.push({
                  event: "e_selectionCta",
                  model: "can-am ryker rotax Rally Edition",
                  country: di.profileManager.region,
                  language: di.localization.locale,
                });
                this.onSelectModel("AR", "903");
              }}
              isExcluded={di.catalogManager.isExcluded("AR.903", region)}
            />
          </div>
        </Container>
      </Grid>
    );
  }
}

// Styles
const classes = (theme) => ({
  container: {
    position: "absolute",
    width: "100%",
    height: "100%",
    bottom: 0,
    right: 0,
    zIndex: 2,
    backgroundColor: "#4a4a4a",
  },
  about: {
    position: "absolute",
    width: "100%",
    height: "100%",
    bottom: 0,
    right: 0,
    zIndex: 5,
    "@global": {
      h1: {
        fontSize: "2.5rem",
        fontWeight: "200",
      },
    },
  },
});

const styles = {
  content: {
    marginBottom: 100,
  },
  cardContainer: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-around",
    alignContent: "space-around",
    height: "100%",
  },
};
// exports
const SelectionPage = customTheme(classes, Selection);
export { SelectionPage };



// WEBPACK FOOTER //
// ./src/pages/Selection/index.js